import cn from 'classnames'
import React from 'react'
import {
   ToastContainer as Container,
   ToastContainerProps
} from 'react-toastify'

import { XCloseIcon } from '@flowwai-frontend/design-system/icons'
import { Button, Hierarchy, SubVariant } from '@flowwai-frontend/design-system'

import {
   LinkType,
   ToastActionType,
   ToastStyles,
   ToastType
} from '../../types/ToastTypes'

import {
   actionsContainerClassName,
   buttonClassName,
   closeContainerStyles,
   containerClassName,
   contentContainerClassName,
   getToastStyles,
   leftIconClassName,
   toastDescriptionStyles,
   toastTitleStyles
} from './styles'

import './index.css'
import { toastTheme } from './toastTheme'

interface ToastComponentProps {
   title: string
   toastType: ToastType
   dismissToast?: () => void
   color?: string

   description?: string

   renderLeftIcon?: (color: string) => React.ReactElement

   actions?: ToastActionType[]

   noteList?: string[]

   rightLink?: LinkType
   showDismissButton?: boolean

   toastClassName?: string
}

const ToastComponent = (props: ToastComponentProps): React.ReactElement => {
   const {
      title,
      description,
      toastType = 'SUCCESS',
      showDismissButton = true,
      rightLink,
      noteList = [],
      actions = [],
      dismissToast,
      renderLeftIcon,
      toastClassName
   } = props

   const {
      bgColor,
      borderColor,
      textColor,
      closeIconColor,
      leftIconColor
   }: ToastStyles = getToastStyles(toastTheme, toastType)

   const renderAdditionalInfo = () => (
      //TODO: update button styles
      <div>
         {description ? (
            <span className={cn(toastDescriptionStyles, textColor)}>
               {description}
            </span>
         ) : null}
         {noteList.length ? (
            <ul className={'list-disc ml-18px'}>
               {noteList.map((note, index) => (
                  <li
                     className={cn(toastDescriptionStyles, textColor)}
                     key={index}
                  >
                     {note}
                  </li>
               ))}
            </ul>
         ) : null}
         {actions.length ? (
            <div className={actionsContainerClassName}>
               {actions.map(action => (
                  <Button
                     hierarchy={action.hierarchy || Hierarchy.Link}
                     subVariant={action.subVariant || SubVariant.Gray}
                     size={'Small'}
                     className={cn(
                        buttonClassName,
                        toastDescriptionStyles,
                        textColor
                     )}
                     key={action.value}
                     onClick={action.onClickAction}
                     leftIcon={action.renderLeftIcon}
                     rightIcon={action.renderRightIcon}
                  >
                     {action.label}
                  </Button>
               ))}
            </div>
         ) : null}
      </div>
   )

   return (
      <div
         className={cn(
            containerClassName,
            bgColor,
            borderColor,
            toastClassName
         )}
      >
         <div className={leftIconClassName}>
            {renderLeftIcon ? renderLeftIcon(leftIconColor) : null}
         </div>
         <div className={contentContainerClassName}>
            <span className={cn(toastTitleStyles, textColor)}>{title}</span>
            {renderAdditionalInfo()}
         </div>
         {showDismissButton || rightLink ? (
            rightLink ? (
               <Button
                  hierarchy={Hierarchy.Link}
                  subVariant={SubVariant.Gray}
                  size={'Small'}
                  className={cn(toastDescriptionStyles, textColor, 'ml-auto')}
                  onClick={() => rightLink.onClickLink()}
                  rightIcon={() => <>{rightLink.renderIcon}</>}
               >
                  {rightLink.label}
               </Button>
            ) : (
               <div
                  className={closeContainerStyles}
                  onClick={() => dismissToast && dismissToast()}
               >
                  <XCloseIcon height={20} width={20} fill={closeIconColor} />
               </div>
            )
         ) : null}
      </div>
   )
}

const ToastContainer = (props: ToastContainerProps) => (
   <Container
      position='bottom-center'
      autoClose={1000}
      hideProgressBar={true}
      newestOnTop={true}
      closeOnClick
      rtl={false}
      draggable
      pauseOnHover
      {...props}
   />
)
export { ToastComponent, ToastContainer }
